import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { useParameterKeys } from 'hooks/useParameterKeys';

const AppConfig = () => {
  const { isMPDFT, applyLightTheme } = useParameterKeys();

  const toastClassName = isMPDFT && applyLightTheme ? 'toast-mpdft-light' : '';

  useEffect(() => {
    if (applyLightTheme) {
      document.body.classList.add('mpdft-light-theme');
    } else {
      document.body.classList.remove('mpdft-light-theme');
    }
  }, [applyLightTheme]);

  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      style={{ width: 'auto', maxWidth: 768 }}
      className={toastClassName}
    />
  );
};

export default AppConfig;
